import { SimpleTable } from "@/core/components/simple-table";
import type { IcmJob } from "@/icm/types";
import { getTableMinWidth } from "@/icm/utils";
import {
  BusinessUnitNameCol,
  CustomerNameCol,
  JobCompletedOnCol,
  JobTotalCol,
  JobTotalPayoutCol,
} from "./cols";

const JOB_COLUMNS = [
  CustomerNameCol,
  BusinessUnitNameCol,
  JobCompletedOnCol,
  JobTotalCol,
  JobTotalPayoutCol,
];
const JOB_TABLE_MIN_WIDTH = getTableMinWidth(JOB_COLUMNS);

interface IcmJobBreakdownTableProps {
  jobs: IcmJob[];
  searchValue: string;
  setSearchValue: (value: string) => void;
  onRowClick: (job: IcmJob | null) => void;
}

export const IcmJobBreakdownTable = ({
  jobs,
  searchValue,
  setSearchValue,
  onRowClick,
}: IcmJobBreakdownTableProps) => (
  <SimpleTable
    data={jobs}
    columns={JOB_COLUMNS}
    getRowId={(row) => String(row.job_id ?? row.customer_name)}
    columnPinning={{ left: ["customer_name"], right: ["total_payout"] }}
    increaseHeaderPadding
    searchValue={searchValue}
    setSearchValue={setSearchValue}
    scrollAreaHeightClassName="h-[58vh]"
    scrollAreaClassName="pr-0"
    onRowClick={onRowClick}
    scrollContentStyle={{ minWidth: JOB_TABLE_MIN_WIDTH }}
  />
);
